import { VacationsScheduleSubordinatesUser } from 'features/vacationsScheduleSubordinates/vacationUser';
import { useTitle } from '../helpers';

/**
 * @page Vacations
 */
const VacationsScheduleSubordinatesUserPage = () => {
  useTitle('Планирование отпусков сотрудников');

  return (
    <div>
      <VacationsScheduleSubordinatesUser />
    </div>
  );
};

export default VacationsScheduleSubordinatesUserPage;
